/* eslint-disable-next-line padded-blocks */
import { ptBR } from "date-fns/locale";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { format } from "date-fns";
import { useForm } from "react-hook-form";
import {  useState } from "react";
import html2pdf from "html2pdf.js";
import ReactDOMServer from "react-dom/server";
//primereact
import { Button } from "primereact/button";
import { Skeleton } from "primereact/skeleton";
import { BreadCrumb } from "primereact/breadcrumb";
//components
import Panel from "../../../components/panel/panel";
import Select from "../../../components/input/Select";
import Toggle from "../../../components/button/Toggle";
import ModelReport from "../../../components/report/ModelReport";
//services
import { postReportLandsAvailable } from "../../../services/Report/postReportLandsAvailable";
//hooks
import { useOptionsSelect } from "../../../hooks/useOptionsSelect";
//pages
import { TableLandsAvailable } from "./TableLandsAvailable";
import { formatCurrency } from "../../../utils/formatCurrency";
import { useAppContext } from "../../../context/AppContext";
import usePermission from "../../../hooks/usePermission";

import * as XLSX from "xlsx";
import Excel from "../../../assets/excel";

const LandsAvailable = () => {
  usePermission("126"); // Visualizar Relatorio de Lotes Disponiveis

  const { nomenclatures, permissions } = useAppContext();
  const nomenclature = JSON.parse(nomenclatures);
  const navigate = useNavigate();


  const [now, setNow] = useState();
  const [user, setUser] = useState();
  const [filters, setFilters] = useState();
  const [logo, setLogo] = useState();
  const [table, setTable] = useState();
  const [visible, setVisible] = useState(false);
  const [loading, setLoading] = useState();
  const defaultValues = {
    view_value: false,
  };
  const form = useForm({ defaultValues });
  const errors = form.formState.errors;
  const items = [
    {
      template: () => (
        <Link to={"/reports/landsAvailable"} className="p-breadcrumb-link">
          {nomenclature[1].value}(s) Disponíveis
        </Link>
      ),
    },
  ];
  const home = {
    template: () => (
      <Link to={"#"} className="p-breadcrumb-link">
        <i className="fa fa-home"></i>
      </Link>
    ),
  };


  const { enterprise, isLoadingEnterprises } = useOptionsSelect();

  const getFormErrorMessage = (name) => {
    return errors[name] ? (
      <small className="p-error">{errors[name].message}</small>
    ) : (
      <small className="p-error">&nbsp;</small>
    );
  };

  const onSubmit = async (data) => {
    const notification = toast.loading(
      "Por favor aguarde a consulta está sendo realizada..."
    );
    data.view_value = data.view_value ? 1 : 0;

    const today = new Date();
    const formattedDate = format(today, "dd 'de' MMMM 'de' yyyy", {
      locale: ptBR,
    });
    setNow(formattedDate);

    try {
      setLoading(true);
      const response = await postReportLandsAvailable(data);
      setTable(response);
      setUser(response.user.name);
      setLogo(response.enterprise.img && response.enterprise.img);
      const newFilters = [
        { title: "Empreendimento", content: response.enterprise.name },
        { title: "Mostrar Valor", content: data.view_value ? "Sim" : "Não" },
      ];
      setFilters(newFilters);
      toast.update(notification, {
        render: "Consulta Realizada!",
        autoClose: 1000,
        theme: "colored",
        type: "success",
        isLoading: false,
      });
      setLoading(false);
      setVisible(true);
    } catch (e) {
      toast.update(notification, {
        render: "Houve um erro a buscar os dados, tente novamente",
        type: "error",
        theme: "colored",
        autoClose: 5000,
        isLoading: false,
      });
    }
  };

  const handlePrint = () => {
    const headerContent = (
      <div style={{ color: "#000000" }}>
        <div>
          <div className="header-contract-land pt-3 pb-2">
            <div className="row">
              <div className="col-md-3 d-flex justify-content-center">
                {logo && <img src={logo} alt="logo" width={100} />}
              </div>
              <div className="col-md-6 text-center pt-4">
                <h3 className="fw-bolder">
                  RELATÓRIO DE DISPONIBILIDADE DE{" "}
                  {nomenclature[1].value.toUpperCase()}
                </h3>
              </div>
              <div className="col-md-3 d-flex justify-content-end pt-4">
                <div className="mx-3 text-center">
                  <h6>{now}</h6>
                  <p style={{ fontSize: "9px" }}>Emitido por: {user}</p>
                </div>
              </div>
            </div>
            <div className="row text-center d-flex justify-content-center my-2">
              {filters.map((item, index) => (
                <div className="w-auto my-2 text-start d-flex" key={index}>
                  <h6 className="mx-3">
                    <span
                      className="fw-bolder text-gray"
                      style={{ fontSize: "13px" }}
                    >
                      {item.title}:{" "}
                    </span>{" "}
                    {item.content ? item.content.toString() : "N/A"}
                  </h6>
                  {index !== filters.length - 1 && (
                    <span className="mx-1" style={{ translate: "0px -2px" }}>
                      {" "}
                      |{" "}
                    </span>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="table-content">
          <div className="my-1 text-center overflow-hidden">
            <TableLandsAvailable table={table?.data} nomenclature={nomenclature} />
          </div>
          <div className="text-end pe-3 mt-3">
            <h5>Quantidade Geral Disponíveis: {table.count_total}</h5>
            {table.sum_value_total && (
              <h5>
                <span className="fw-bolder">
                  Valor Total Geral Disponíveis:
                </span>{" "}
                {table.sum_value_total && formatCurrency(table.sum_value_total)}
              </h5>
            )}
          </div>
        </div>
      </div>
    );
    const htmlString = ReactDOMServer.renderToString(headerContent);

    const options = {
      margin: 30,
      filename: `relatorio_${nomenclature[1].value}_disponiveis.pdf`,
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: "pt", format: "letter", orientation: "portrait" },
    };

    const addPageNumbers = (pdf) => {
      const totalPages = pdf.internal.getNumberOfPages();
      for (let i = 1; i <= totalPages; i++) {
        pdf.setPage(i);
        pdf.setFontSize(10);
        pdf.setTextColor(100);
        pdf.text(
          `Página ${i} de ${totalPages}`,
          pdf.internal.pageSize.getWidth() - 100,
          pdf.internal.pageSize.getHeight() - 15
        );
      }
    };

    const generatePDF = () => {
      // const pdf = new jsPDF(options.jsPDF);
      html2pdf()
        .from(htmlString)
        .set(options)
        .toPdf()
        .get("pdf")
        .then(function (pdfDoc) {
          addPageNumbers(pdfDoc);
          pdfDoc.save(options.filename);
        });
    };

    generatePDF();
  };

  const exportToExcel = (sheetName) => {
    // console.log("table", table);
    const customName = nomenclature[1].value.toLowerCase();
    const customName2 = nomenclature[0].value.toLowerCase();
  
    const adjustedData = table.data.flatMap((item) =>
      item.lands.map((land) => ({
        id: land.id,
        [customName2]: item.name,
        [customName]: land.name,
        m2: land.m2,
      }))
    );
    
    // console.log("Adjusted Data: ", adjustedData)
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet(adjustedData);  // Usa os dados ajustados
    XLSX.utils.book_append_sheet(wb, ws, sheetName);
    XLSX.writeFile(wb, `relatório_${customName}_disponíveis.xlsx`);
  };  

  return (
    <div className="row d-flex justify-content-between mb-3">
      <div>
        <BreadCrumb
          model={items}
          home={home}
          style={{
            background: "transparent",
            border: "none",
            fontSize: "16px",
          }}
        />
      </div>
      <Panel title={`Relatório de disponibilidade de ${nomenclature[1].value}`}>
        <form onSubmit={form.handleSubmit(onSubmit)}>
          <div className="row d-flex mt-4">
            <div className="col-xl-4 col-md-6 mb-3 form-group">
              <Select
                control={form.control}
                label={
                  isLoadingEnterprises ? "Carregando..." : "Empreendimento*"
                }
                name="enterprise_id"
                disabled={isLoadingEnterprises}
                isRequired={true}
                options={enterprise}
                errors={errors}
              />
            </div>
            <div className="col-xl-2 col-md-6 my-2 form-group pt-2">
              <Toggle
                control={form.control}
                name="view_value"
                onLabel="Exibir Valor"
                offLabel="Exibir Valor"
                getFormErrorMessage={getFormErrorMessage}
              />
            </div>
            <div className="d-flex justify-content-end">
              <div
                className={`${window.innerWidth <= 992 ? "w-25" : "col-md-1"
                  } text-center`}
              >
                <Button
                  type="submit"
                  icon="fa fa-search"
                  aria-label="Search"
                  loading={loading}
                  className={`rounded-3 py-2.5 w-100`}
                />
              </div>
            </div>
          </div>
        </form>
      </Panel>

      {loading && <Skeleton width="100%" height="500px" className="mt-4" />}

      {visible && !loading && (
        <Panel mainCss="mt-4">
          <>
            {/* <hr className="my-4" /> */}
            <div className="px-2 pb-3">
              <div className="d-flex justify-content-end">
              <Button
                  onClick={() => exportToExcel(`Relatório de ${nomenclature[1].value.toUpperCase()}`)}
                  icon="fa fa-file-excel"
                  label=""
                  tooltip="Exportar para Excel"
                  tooltipOptions={{ position: "bottom" }}
                  iconPos="center"
                  className="m-2 p-button-success"
                  rounded
                />
                <Button
                  onClick={() => handlePrint()}
                  icon="fa fa-file-pdf"
                  className="p-button-secondary cursor-pointer my-2 mx-2 me-0"
                  iconPos="center"
                  rounded
                  tooltip="Exportar para PDF"
                  tooltipOptions={{ position: "top" }}
                />
              </div>
              <ModelReport
                date={now}
                madeBy={user}
                logo={logo}
                title={`RELATÓRIO DE DISPONIBILIDADE DE ${nomenclature[1].value.toUpperCase()}`}
                filters={filters}
              >
                <div className="text-center overflow-hidden">
                  {table.length === 0 ? (
                    <div className="d-flex flex-column align-items-center mt-4">
                      <h4
                        className="p-3 fw-bolder"
                        style={{ translate: "0px -10px" }}
                      >
                        Nenhuma Informação Encontrada
                      </h4>
                    </div>
                  ) : (
                    <>
                      <TableLandsAvailable table={table.data} nomenclature={nomenclature} />
                      <div className="text-end pe-3 mt-3">
                        <h5>
                          <span className="fw-bolder">
                            Quantidade Geral Disponíveis:
                          </span>{" "}
                          {table.count_total}
                        </h5>
                        {table.sum_value_total && (
                          <h5>
                            <span className="fw-bolder">
                              Valor Total Geral Disponíveis:
                            </span>{" "}
                            {table.sum_value_total &&
                              formatCurrency(table.sum_value_total)}
                          </h5>
                        )}
                      </div>
                    </>
                  )}
                </div>
              </ModelReport>
            </div>
          </>
        </Panel>
      )}
    </div>
  );
};

export default LandsAvailable;
